import 'whatwg-fetch';
import { message } from 'antd';
import history from './history';
import qs from 'qs';
import { apiDomain } from './config';

// 获取url
export const fGetUrl = options => {
  const mode = process.env.NODE_ENV;
  let { url, params = {} } = options;
  const { method = 'get' } = params;
  // 根据mode获取具体域名

  url = apiDomain[mode] + url + '?';

  //get请求将parms拼接到url上
  if (method === 'get') {
    for (let keys in params) {
      if (Object.prototype.hasOwnProperty.call(params, keys)) {
        url = url + '&' + keys + '=' + params[keys];
      }
    }
  }
  return url;
};

const getFormDataFromValues = values => {
  const formData = new FormData();

  for (let key in values) {
    formData.append(key, values[key]);
  }

  return formData;
};

const request = options => {
  let { url, params = {} } = options;
  const { method = 'get', ifTip, isFormData = false } = params;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  };

  // 去除空字符串
  // 20221229 undefined null 空字符串
  for (const keys in params) {
    if (typeof params[keys] === 'undefined' || params[keys] === null || params[keys] === '') {
      delete params[keys];
    }
  }

  url = fGetUrl(options);
  delete params.method;
  delete params.ifTip;
  delete params.isFormData;

  const body = isFormData
    ? getFormDataFromValues(params)
    : method === 'post' || method === 'put' || method === 'delete'
    ? qs.stringify(params)
    : null;

  if (isFormData) {
    delete headers['Content-Type'];
  }

  return fetch(url, {
    method,
    body,
    credentials: 'include',
    headers,
  })
    .then(res => res.json())
    .then(res => {
      const { data, flag, msg } = res;

      if (flag === 403) {
        message.error('没有权限！');
      } else if (flag === 401) {
        message.error('登录状态已过期，请重新登录', 1, () => {
          history.replace('/login');
        });
      } else if (method !== 'get' && flag !== 200) {
        message.error(msg);
      } else if (flag === 200 && ifTip) {
        message.success('成功!');
      }

      return window.Promise.resolve({
        flag,
        data,
        msg,
      });
    });
};

// 成功时直接返回data，失败时抛出错误
export const extractResponseData = res => {
  const { flag, data, msg } = res;

  if (flag === 200) {
    return data;
  } else {
    throw new Error(msg || '请求失败');
  }
};

export default request;
